import { combineReducers } from 'redux';
import global from './global/globalSlice';
import user from './user/userSlice';
import school from './school/schoolSlice';
import survey from './survey/surveySlice';
import indicator from './indicator/indicatorSlice';
import exam from './exam/examSlice';
import competition from './competition/competitionSlice';
import bvm from './bvm/bvmSlice';
import projects from './projects/projectsSlice';
import centerAccreditation from './center-accreditation/centerAccreditationSlice';
/**
 * ## CombineReducers
 *
 * the rootReducer will call each and every reducer with the state and action
 * EVERY TIME there is a basic action
 */
const appReducers = combineReducers({
    // ... your other reducers here ...
    global,
    user,
    school,
    survey,
    indicator,
    exam,
    competition,
    bvm,
    projects,
    centerAccreditation,
});
export default appReducers;
